// MyRISOpexTable.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Table, Input } from "antd";
import "antd/dist/reset.css";
const { Search } = Input;

export default function MyRISOpexTable({tableData, sectorData, opexTableTitle, opexTableHeader}) {

  const [searchText, setSearchText] = useState("");
  const columns = [
    {
      title: "DESCRIPTION",
      dataIndex: "section",
      key: "section",
      width: 180,
      className: "col-section",
      render: (text, record) => {
        const rowSpan = record.isFirstSectionRow ? record.sectionCount : 0;
        return { 
          // children: <strong>{text}</strong>, 
          children: text, 
          props: { rowSpan, className: "col-section" } 
        };
      },
    },
    {
      title: "",
      dataIndex: "parent",
      key: "parent",
      width: 360,
      className: "col-parent",
      render: (text, record) => {
        const rowSpan = record.isFirstParentRow ? record.parentCount : 0;
        return { 
          children: text, 
          props: { rowSpan, className: "col-parent" } 
        };
      },
    },
    {
      title: "KPI",
      dataIndex: "kpi",
      key: "kpi",
      width: 360,
    },
    ...(sectorData?.map((col) => ({
      title: col.toUpperCase(),
      dataIndex: col,
      key: col,
      className: `col-${col}`,
      align: "left",
      width: 110,
      render: (text) =>
        col.toLowerCase() === "global" ? <strong>{text}</strong> : text,
    })) ?? []),
  ];
  
  const data = useMemo(() => {
    // Count section sizes
    const sectionCounts = tableData?.reduce((acc, r) => {
      acc[r.section] = (acc[r.section] || 0) + 1;
      return acc;
    }, {});
    // Count section+parent sizes
    const parentCounts = tableData?.reduce((acc, r) => {
      const key = `${r.section}__${r.parent}`;
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});
    const seenSections = new Set();
    const seenParents = new Set();

    return tableData?.map((r) => {
      const secFirst = !seenSections.has(r.section);
      seenSections.add(r.section);

      const parentKey = `${r.section}__${r.parent}`;
      const parFirst = !seenParents.has(parentKey);
      seenParents.add(parentKey);

      return {
        ...r,
        sectionCount: sectionCounts[r.section],
        parentCount: parentCounts[parentKey],
        isFirstSectionRow: secFirst,
        isFirstParentRow: parFirst,
      };
    });
  }, [tableData]);

    // 🟢 Generic filter function (works for dynamic columns)
    const filteredData = data.filter((item) =>
    columns.some((col) => {
      const value = item[col.dataIndex];
      return value
        ? value.toString().toLowerCase().includes(searchText.toLowerCase())
        : false;
    })
  );

    // generic string sorter
    const stringSorter = (a, b, key) =>
    (a[key] || "").localeCompare(b[key] || "");

    // generic number sorter
    const numberSorter = (a, b, key) =>
    Number(a[key] || 0) - Number(b[key] || 0);

  return (
    <div style={{ width: '100%' }}>
      {/* <Search
        placeholder="Search..."
        allowClear
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: 16, width: 300, float: 'right', position: 'relative', bottom: '3rem', right: '4rem' }}
      /> */}
        <Table
          className="kpi-opex-table"
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered
          scroll={{ x: 700 }}
          title={() => (
            <div style={{ textAlign: "center", fontWeight: 500, fontSize: "16px", color: '#616161'}} className="opex-ant-table-title">
              {opexTableTitle}
            </div>
          )}
        />
    </div>
  );
}


